
import { RevCardCarousel } from '@ds/components/CardCarousel'
import { RevEditorialCard } from '@ds/components/EditorialCard'

import { ROUTES } from '@router'
import { trackClick } from '@tracking/events'

import {
  SEO_DATA_SELECTOR_COMPARISON_CARD,
  TOP_COMPARISONS,
} from './SuggestedComparisons.constants'
import translations from './SuggestedComparisons.translations'

export default {
  components: {
    RevCardCarousel,
    RevEditorialCard,
  },

  props: {
    comparisons: {
      type: Array,
      required: true,
    },
  },

  computed: {
    translations: () => translations,
    dataSelectorForSeo: () => SEO_DATA_SELECTOR_COMPARISON_CARD,
    placeholderImage: () => TOP_COMPARISONS[0].image,
  },

  methods: {
    getTemporaryLink(link) {
      // [ACQ-646] While we're refactoring Versus we have to
      // deal with legacy route names in links like here.
      // This will be removed after migration is done.
      return {
        ...link,
        name: ROUTES.MODELS_COMPARISON.COMPARISON_RESULTS,
      }
    },
    trackComparisonCardClick(comparison) {
      trackClick({
        name: comparison.customContent.title,
      })
    },
  },
}
